import { useSelector } from 'react-redux';

export const useCategories = () => {
    return useSelector((state) => state.categories);
};

export const useCategoriesWithoutOther = () => {
    return useSelector((state) => state.categories?.filter(c => c.categoryId !== 'other'));
};
